<div [ngClass]="{'z-10': isEditMode }" class="inline-flex relative w-full border border-white dark:border-surface-900 gap-2 items-center rounded-full text-surface-800 bg-surface-100 dark:text-surface-0 dark:bg-surface-800 !py-0 !pl-4 !pr-0">
  <div class="text-nowrap">{{label}} :</div>
  @if (isEditMode) {
    @if (type == 'text') {
      <div class="grow"><input pInputText fluid [pAutoFocus]="true" [(ngModel)]="value" (keyup.enter)="onSaveValue()" (keyup.escape)="onInputClose()" type="text" pSize="small" maxlength="{{limit}}" placeholder="{{label}}" class="product-line-field" /></div>
    }
    @if (type == 'link') {
      <div class="grow"><input pInputText fluid [pAutoFocus]="true" [(ngModel)]="value" (keyup.enter)="onSaveValue()" (keyup.escape)="onInputClose()" type="url" pSize="small" maxlength="{{limit}}" placeholder="{{label}}" class="product-line-field" /></div>
    }
    @if(type == 'number') {
      <div class="grow"><p-inputnumber fluid [pAutoFocus]="true" [(ngModel)]="value" mode="decimal" locale="fr-FR" [minFractionDigits]="2" (keyup.enter)="onSaveValue()" (keyup.escape)="onInputClose()" size="small" placeholder="{{label}}" class="product-line-field"/></div>
    }
    @if (type == 'select') {
      <div class="grow">
        <p-select [options]="selectOptions" [loading]="isLoadingMode" [pAutoFocus]="true" fluid appendTo="body" pSize="small" [(ngModel)]="value" optionLabel="nom" [filter]="true" filterBy="nom" (onFilter)="onSelectFilter($event)" size="small" class="w-full min-w-40" />
      </div>
    }
  }
  @else {
    @if(value?.nom) {
      <div class="grow">{{ `${value.nom ?? '~'}${suffix}` }}</div>
    }
    @else {
      <div class="grow truncate ">{{ `${(value && value != '') ? value : '~'}${suffix}` }}</div>
    }
  }
  <p-buttongroup>
    @if (isEditMode) {
      <p-button (click)="onSaveValue()" icon="pi pi-save" [rounded]="true" [text]="true" severity="success" />
      <p-button (click)="onInputClose()" icon="pi pi-times-circle" [rounded]="true" [text]="true" severity="danger" />
    }
    @else {
      <p-button (click)="onToggleMode()" icon="pi pi-pencil" [rounded]="true" [text]="true" severity="info" [loading]="isSendingInputData" [disabled]="isSendingInputData || isDisabled"/>
    }
    @if (type == 'link' && value) {
      <a pButton [href]="value" target="_blank" [rounded]="true" [text]="true" severity="info"><span pButtonIcon class="pi pi-external-link"></span></a>
    }
  </p-buttongroup>
</div>
